












import Vue from 'vue'
import RequestInfoDialog from '@/components/dialogs/privacy/RequestInfoDialog.vue'
import ActionDialog from '@/components/atoms/ActionDialog.vue'

export default Vue.extend({
  components: {
    RequestInfoDialog,
    ActionDialog
  },
  data: () => ({
    dialogVisible: false as boolean
  }),
  methods: {
    showDialog (): void {
      this.dialogVisible = true
    },
    hideDialog (): void {
      this.dialogVisible = false
    }
  }
})
